import { render, staticRenderFns } from "./IconSvgClose.vue?vue&type=template&id=9a19d446&scoped=true&"
import script from "./IconSvgClose.vue?vue&type=script&lang=js&"
export * from "./IconSvgClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a19d446",
  null
  
)

export default component.exports